var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectromagneticDoor01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.43,13.44H2.55V2.56h10.88V13.44z M3.05,12.94h9.88V3.06H3.05V12.94z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.8,
    y: 2.81,
    className: "st2",
    width: 5.28,
    height: 5.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.33,8.1H2.55V2.56h5.79V8.1z M3.05,7.6h4.79V3.06H3.05V7.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.84,
    y: 8.01,
    className: "st2",
    width: 5.28,
    height: 5.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.38,13.3H7.59V7.76h5.78V13.3z M8.09,12.8h4.78V8.26H8.09V12.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectromagneticDoor01);
export default __webpack_public_path__ + "static/media/ElectromagneticDoor-01.735aa18e20b3497752c31561893f7e46.svg";
export { ForwardRef as ReactComponent };